import { SectionsAnalyticsPage } from "../SectionsAnalyticsPage/index";

const SectionsAnalyticsStayPage = () => (
  <SectionsAnalyticsPage analyticsType="stay" />
);

export default SectionsAnalyticsStayPage;
